import { DocumentRequirementCardSkeleton } from '@/components/dashboard/DocumentRequirementCardSkeleton'
import {
  DashboardSectionHeading,
  DashboardSidebarHeader,
  DashboardWelcomeSection,
} from '@/components/dashboard/dashboardLayout'
import { ProgressSummaryCard } from '@/components/dashboard/ProgressSummaryCard'
import { SecurityCard } from '@/components/dashboard/SecurityCard'
import { Skeleton } from '@/components/ui/skeleton'

interface DashboardSkeletonProps {
  /** When false, only the grid body is shown (header already rendered with real user data). */
  showWelcome?: boolean
}

export function DashboardSkeleton({ showWelcome = true }: DashboardSkeletonProps) {
  return (
    <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6 lg:px-8 lg:py-12">
      {showWelcome && (
        <DashboardWelcomeSection>
          <div className="overflow-hidden rounded-2xl border border-border/60 bg-white shadow-[0_2px_16px_rgba(0,0,0,0.04)]">
            <div className="h-[3px] bg-primary-to-purple-gradient" aria-hidden="true" />
            <div className="p-5 sm:p-6">
              <div className="flex items-center justify-between gap-3">
                <Skeleton className="h-6 w-48 sm:h-7" />
                <Skeleton className="h-8 w-28 shrink-0 rounded-full" />
              </div>
              <Skeleton className="mt-3 h-8 w-44 rounded-full" />
              <div className="mt-5 space-y-2 border-t border-border/50 pt-5">
                <Skeleton className="h-4 w-full max-w-xl" />
                <Skeleton className="h-4 w-72 max-w-full" />
              </div>
            </div>
          </div>
        </DashboardWelcomeSection>
      )}

      <div className="grid gap-6 lg:grid-cols-3 lg:items-start lg:gap-8">
        <aside className="order-1 space-y-4 lg:order-2 lg:sticky lg:top-24 lg:self-start">
          <DashboardSidebarHeader />
          <ProgressSummaryCard items={[]} isLoading />
          <SecurityCard />
        </aside>

        <div className="order-2 space-y-8 lg:order-1 lg:col-span-2">
          <section className="space-y-4">
            <DashboardSectionHeading>Required documents</DashboardSectionHeading>
            <div className="space-y-4">
              <DocumentRequirementCardSkeleton />
              <DocumentRequirementCardSkeleton />
              <DocumentRequirementCardSkeleton />
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}
